// Mock data shared across all dashboards (hôtesse / partenaire / admin)

export type CampaignStatus = 'active' | 'scheduled' | 'ended' | 'draft' | 'review';
export type GameType = 'grattage' | 'roulette' | 'tombola';

export interface Campaign {
  id: string;
  name: string;
  brand: string;
  game: GameType;
  status: CampaignStatus;
  startDate: string;
  endDate: string;
  participations: number;
  prizesGiven: number;
  prizesRemaining: number;
  totalPrizes: number;
  winRate: number; // %
  city: string;
}

export interface Validation {
  id: string;
  participantName: string;
  prize: string;
  code: string;
  time: string; // HH:MM
  status: 'validated' | 'pending' | 'expired';
}

export interface Lead {
  id: string;
  name: string;
  email: string;
  phone: string;
  campaignId: string;
  city: string;
  optIn: boolean;
  date: string;
}

export interface UserRow {
  id: string;
  name: string;
  email: string;
  role: 'participant' | 'hotesse' | 'partenaire' | 'admin';
  status: 'active' | 'suspended';
  joined: string;
  city: string;
}

export const campaigns: Campaign[] = [
  {
    id: 'cmp_orange_fest',
    name: 'Festival Orange Abidjan',
    brand: 'Orange CI',
    game: 'grattage',
    status: 'active',
    startDate: '2026-04-12',
    endDate: '2026-04-30',
    participations: 4820,
    prizesGiven: 612,
    prizesRemaining: 188,
    totalPrizes: 800,
    winRate: 45,
    city: 'Abidjan',
  },
  {
    id: 'cmp_didi_b',
    name: 'Concert Didi B — Palais',
    brand: 'MTN',
    game: 'roulette',
    status: 'active',
    startDate: '2026-04-20',
    endDate: '2026-04-25',
    participations: 1240,
    prizesGiven: 142,
    prizesRemaining: 58,
    totalPrizes: 200,
    winRate: 52,
    city: 'Abidjan',
  },
  {
    id: 'cmp_jazz_lome',
    name: 'Jazz de Lomé 2026',
    brand: 'Ramco',
    game: 'tombola',
    status: 'scheduled',
    startDate: '2026-05-08',
    endDate: '2026-05-12',
    participations: 0,
    prizesGiven: 0,
    prizesRemaining: 300,
    totalPrizes: 300,
    winRate: 38,
    city: 'Lomé',
  },
  {
    id: 'cmp_supermarche',
    name: 'Activation Prosuma',
    brand: 'Prosuma',
    game: 'grattage',
    status: 'ended',
    startDate: '2026-03-01',
    endDate: '2026-03-31',
    participations: 8910,
    prizesGiven: 1230,
    prizesRemaining: 0,
    totalPrizes: 1230,
    winRate: 41,
    city: 'Abidjan',
  },
  {
    id: 'cmp_review',
    name: 'Lancement Yango Pro',
    brand: 'Yango',
    game: 'roulette',
    status: 'review',
    startDate: '2026-05-01',
    endDate: '2026-05-15',
    participations: 0,
    prizesGiven: 0,
    prizesRemaining: 500,
    totalPrizes: 500,
    winRate: 30,
    city: 'Dakar',
  },
];

export const validations: Validation[] = [
  {
    id: 'v1',
    participantName: 'Koffi Arman',
    prize: 'Billet VIP Didi B',
    code: 'JZ4-X72K',
    time: '18:42',
    status: 'validated',
  },
  {
    id: 'v2',
    participantName: 'Fatou Diop',
    prize: 'Pass backstage',
    code: 'MN7-P21A',
    time: '18:37',
    status: 'validated',
  },
  {
    id: 'v3',
    participantName: 'Moussa Traoré',
    prize: 'T-shirt collector',
    code: 'BX2-Q88L',
    time: '18:31',
    status: 'validated',
  },
  {
    id: 'v4',
    participantName: 'Awa Bamba',
    prize: 'Data 10 Go Orange',
    code: 'RT9-K14M',
    time: '18:24',
    status: 'pending',
  },
  {
    id: 'v5',
    participantName: 'Yves Konan',
    prize: 'Bon Ramco 25 000 F',
    code: 'VC8-D33H',
    time: '18:11',
    status: 'validated',
  },
  {
    id: 'v6',
    participantName: 'Linda Aké',
    prize: 'Goodie pack',
    code: 'GH5-Z71B',
    time: '17:58',
    status: 'expired',
  },
  {
    id: 'v7',
    participantName: 'Sidi Camara',
    prize: 'Billet VIP Didi B',
    code: 'QW3-N62R',
    time: '17:42',
    status: 'validated',
  },
];

export const leads: Lead[] = [
  {
    id: 'l1',
    name: 'Koffi Arman',
    email: 'koffi@mail.ci',
    phone: '+225 07 12 34 56',
    campaignId: 'cmp_didi_b',
    city: 'Abidjan',
    optIn: true,
    date: '2026-04-22',
  },
  {
    id: 'l2',
    name: 'Fatou Diop',
    email: 'fatou.d@mail.sn',
    phone: '+221 77 854 21 09',
    campaignId: 'cmp_orange_fest',
    city: 'Dakar',
    optIn: true,
    date: '2026-04-22',
  },
  {
    id: 'l3',
    name: 'Moussa Traoré',
    email: 'moussa.t@mail.ci',
    phone: '+225 05 88 11 02',
    campaignId: 'cmp_orange_fest',
    city: 'Abidjan',
    optIn: true,
    date: '2026-04-21',
  },
  {
    id: 'l4',
    name: 'Awa Bamba',
    email: 'awa.b@mail.ci',
    phone: '+225 07 99 04 18',
    campaignId: 'cmp_didi_b',
    city: 'Abidjan',
    optIn: false,
    date: '2026-04-21',
  },
  {
    id: 'l5',
    name: 'Yves Konan',
    email: 'yves.k@mail.ci',
    phone: '+225 01 47 22 90',
    campaignId: 'cmp_orange_fest',
    city: 'Abidjan',
    optIn: true,
    date: '2026-04-20',
  },
  {
    id: 'l6',
    name: 'Linda Aké',
    email: 'linda.a@mail.ci',
    phone: '+225 07 31 55 60',
    campaignId: 'cmp_didi_b',
    city: 'Abidjan',
    optIn: true,
    date: '2026-04-20',
  },
  {
    id: 'l7',
    name: 'Sidi Camara',
    email: 'sidi.c@mail.ml',
    phone: '+223 76 84 23 11',
    campaignId: 'cmp_orange_fest',
    city: 'Bamako',
    optIn: true,
    date: '2026-04-19',
  },
];

export const users: UserRow[] = [
  {
    id: 'u1',
    name: 'Koffi Arman',
    email: 'koffi@mail.ci',
    role: 'participant',
    status: 'active',
    joined: '2026-02-12',
    city: 'Abidjan',
  },
  {
    id: 'u2',
    name: 'Anike Aya',
    email: 'anike.aya@winko.ci',
    role: 'hotesse',
    status: 'active',
    joined: '2026-01-08',
    city: 'Abidjan',
  },
  {
    id: 'u3',
    name: 'Marie Koné',
    email: 'marie.k@orange.ci',
    role: 'partenaire',
    status: 'active',
    joined: '2025-11-20',
    city: 'Abidjan',
  },
  {
    id: 'u4',
    name: 'Hervé Soro',
    email: 'herve.s@mtn.ci',
    role: 'partenaire',
    status: 'active',
    joined: '2025-12-04',
    city: 'Abidjan',
  },
  {
    id: 'u5',
    name: 'Adama Niang',
    email: 'adama@mail.sn',
    role: 'participant',
    status: 'suspended',
    joined: '2026-03-01',
    city: 'Dakar',
  },
  {
    id: 'u6',
    name: 'Équipe Winkô',
    email: 'ops@winko.app',
    role: 'admin',
    status: 'active',
    joined: '2025-09-01',
    city: 'Abidjan',
  },
];

// Time-series for charts (last 14 days)
export const participationsTrend = Array.from({ length: 14 }).map((_, i) => ({
  day: `J-${13 - i}`,
  participations: Math.round(180 + Math.sin(i / 2) * 80 + i * 18 + Math.random() * 60),
  gains: Math.round(60 + Math.sin(i / 2) * 30 + i * 7 + Math.random() * 30),
}));

export const cityBreakdown = [
  { city: 'Abidjan', value: 58 },
  { city: 'Dakar', value: 14 },
  { city: 'Lomé', value: 11 },
  { city: 'Bamako', value: 9 },
  { city: 'Yaoundé', value: 8 },
];

export const gameBreakdown = [
  { game: 'Grattage', value: 62 },
  { game: 'Roulette', value: 24 },
  { game: 'Tombola', value: 14 },
];

export const fmt = {
  number: (n: number) => new Intl.NumberFormat('fr-FR').format(n),
  pct: (n: number) => `${n}\u00a0%`,
};

export const statusLabels: Record<CampaignStatus, string> = {
  active: 'Active',
  scheduled: 'Programmée',
  ended: 'Terminée',
  draft: 'Brouillon',
  review: 'En revue',
};

export const statusColors: Record<CampaignStatus, string> = {
  active: 'bg-emerald-500/15 text-emerald-700 border-emerald-500/30',
  scheduled: 'bg-accent/15 text-accent border-accent/30',
  ended: 'bg-muted text-muted-foreground border-border',
  draft: 'bg-amber-500/15 text-amber-700 border-amber-500/30',
  review: 'bg-primary/15 text-primary border-primary/30',
};

export const gameLabels: Record<GameType, string> = {
  grattage: 'Grattage',
  roulette: 'Roulette',
  tombola: 'Tombola',
};
